import {
  LocationRead,
  PackageDealApi,
  PackageDealApiLocationsBasePackageDealCollectionRequest,
  PackageDealApiReservationBasePackageDealCollectionRequest,
  ReservationDayHallRead,
} from '@/api';
import axios from 'axios';
import { Module } from 'vuex';

function getPackageDealApi(): PackageDealApi {
  return new PackageDealApi(undefined, import.meta.env.VITE_PROXY_URL, axios);
}

export const PackageDeals: Module<any, any> = {
  namespaced: true,

  actions: {
    async fetchBasePackageDeal(
      _,
      parameters: {
        email: string;
        selectedLocation: LocationRead;
        date: string;
        startTime: string;
        endTime: string;
        pax: number;
      },
    ) {
      const request = {
        id: parameters.selectedLocation.id,
        ...parameters,
      } as PackageDealApiLocationsBasePackageDealCollectionRequest;
      const packageDealApi = getPackageDealApi();
      const response =
        await packageDealApi.locationsIdpackageDealsGetCollection(request);

      return response.data['hydra:member'];
    },

    async fetchReservationPackageDeal(
      _,
      parameters: { hall: ReservationDayHallRead; id: number },
    ) {
      parameters.hall.id = parameters.id;
      const packageDealApi = getPackageDealApi();
      const response =
        await packageDealApi.reservationBasePackageDealCollection(
          parameters.hall as PackageDealApiReservationBasePackageDealCollectionRequest,
        );
      return response.data['hydra:member'];
    },
  },
};
